import { Color } from '@eggplant/pattern-library'
import type {
  CSSProperties,
  ReactNode
} from 'react'

const footerStyle: CSSProperties = {
  paddingTop: '16px',
  display: 'grid',
  rowGap: '8px'
}

const childrenWrapperStyle: CSSProperties = {
  display: 'grid',
  gridAutoFlow: 'column',
  gridColumnGap: '.5em',
  alignItems: 'center',
  justifyContent: 'left'
}

interface Props {
  children: ReactNode
  Icon?: ReactNode
  info?: ReactNode
}

const Footer = ({
  Icon,
  info,
  children
}: Props) =>
  <div>
    <div style={footerStyle}>
      <span style={childrenWrapperStyle}>
        {
          Icon &&
            <Color variant='theme-filter-icon'>
              {Icon}
            </Color>
        }
        {children}
      </span>
      {
        !!info &&
          <span style={childrenWrapperStyle}>
            <span style={{ width: '2em' }} /> {/* Act as 2em Icon */}
            {info}
          </span>
      }
    </div>
  </div>

export default Footer
